var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"vh-100 overflow-y p-0 bg-darkblue",attrs:{"fluid":"","id":"app"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }